import {
  BorderRadius8,
  GreyGrey20,
  GreyGrey50,
  GreyGrey70,
  IconSquareBehindSquare,
  IndigoIndigo10,
  IndigoIndigo60,
  Primary13SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import { Status } from '../usePublishedStatus'
import { PublishedStatus } from '../hooks'

const styles = {
  base: {
    backgroundColor: GreyGrey20,
    height: '32px',
    alignItems: 'center',
    borderRadius: BorderRadius8,
    justifyContent: 'center',
    ...Primary13SemiBold,
    width: '100%',
    gap: '4px',
    userSelect: 'none' as const
  }
}

const STATUS_TO_LABEL: Record<Status | PublishedStatus, string> = {
  [Status.Accepted]: 'Signed',
  [Status.Executed]: 'Executed',
  [Status.Published]: 'Published',
  [Status.NotPublished]: 'Not published',
  [Status.Template]: 'Template',
  [PublishedStatus.PreparingSignatureRequest]: 'Preparing signature request',
  [PublishedStatus.ReadyToSign]: 'Ready to sign',
  [PublishedStatus.ProcessingSignatures]: 'Processing signatures',
  [PublishedStatus.WaitingForApproval]: 'Waiting for review',
  [PublishedStatus.Archived]: 'Archived'
}

interface StatusBadgeProps {
  status: Status | PublishedStatus
  'data-testid'?: string
}

export const StatusBadge = ({
  status,
  'data-testid': dataTestId
}: StatusBadgeProps) => {
  if (status === Status.Template) {
    return (
      <Flex
        {...styles.base}
        color={IndigoIndigo60}
        backgroundColor={IndigoIndigo10}
        data-testid={dataTestId}
      >
        <IconSquareBehindSquare color={IndigoIndigo60} />
        Template
      </Flex>
    )
  }

  return (
    <Flex
      {...styles.base}
      color={status === Status.NotPublished ? GreyGrey50 : GreyGrey70}
      data-testid={dataTestId}
    >
      {status !== Status.NotPublished &&
        status !== PublishedStatus.Archived && (
          <Box
            width="8px"
            height="8px"
            borderRadius="100%"
            backgroundColor="#3BB273"
          />
        )}
      {STATUS_TO_LABEL[status]}
    </Flex>
  )
}
